import React from 'react';
import { Box, Typography } from "@mui/material";

const Consents = () => {
  return (
    <Box m="20px">
      <Typography variant="h2" color="primary">
        Farmer Seed Page
      </Typography>
      <Typography variant="body1">
        Here is the consents for the Farmer consents page.
      </Typography>
    </Box>
  );
};

export default Consents;